import { ACTIVE, INACTIVE, NEEDS_REVIEW } from 'AccountsApp/ts/constants/integrations.constants';
import { EMoneyIntegrationService } from 'IntegrationsApp/ts/services/emoney-integration-service';
import { ConfirmModalComponent } from 'NewAngular/features/components/modals/confirm-modal/confirm-modal.component';
import * as i0 from "@angular/core";
import * as i1 from "IntegrationsApp/ts/services/emoney-integration-service";
import * as i2 from "../../../../../../../../../../../ycharts/static/ts/features/components/modals/confirm-modal/confirm-modal.component";
import * as i3 from "NewAngular/features/directives/image/image.directive";
import * as i4 from "../integration-status-indicator/integration-status-indicator.component";
const _c0 = ["emoneyDeactivateModalComponent"];
const _c1 = ["emoneyActivateModalComponent"];
const _c2 = ["ycn-emoney-integration-list-item", ""];
export class EMoneyIntegrationListItemComponent {
    constructor(emoneyIntegrationService) {
        this.emoneyIntegrationService = emoneyIntegrationService;
        this.status = '';
        this.errorMessage = '';
        this.innerHtml = '<p><strong>To connect your eMoney integration to YCharts, log in to your eMoney account.</strong></p>\n' +
            '<p>Once you log into your eMoney account from this portal, you’ll return to YCharts and be able to import holdings from eMoney.</p>';
    }
    ngOnInit() {
        this.updateStatus();
    }
    updateStatus() {
        this.emoneyIntegrationService.getEMoneyIntegrationStatus().subscribe({
            next: (data) => {
                if (data.isActive) {
                    this.status = ACTIVE;
                }
                else if (!data.isActive && data.errorMessage === null) {
                    this.status = INACTIVE;
                }
                else if (!data.isActive && data.errorMessage !== null) {
                    this.status = NEEDS_REVIEW;
                    this.errorMessage = data.errorMessage;
                }
            },
            error: () => { },
        });
    }
    activateHandler(confirmed) {
        if (confirmed) {
            window.location.href = `${this.authUrl}?response_type=code&redirect_uri=${this.redirectUri}&client_id=${this.clientId}&response_mode=query&nonce=yc_nonce&state=yc_state&scope=offline_access platform:clients:planning:read platform:clients:read`;
        }
        else {
            this.status = INACTIVE;
        }
    }
    deactivateHandler(confirmed) {
        if (confirmed) {
            this.emoneyIntegrationService.deactivateEMoneyIntegration().subscribe((res) => {
                if (res.status === 200) {
                    this.updateStatus();
                }
            });
        }
    }
    activateToggle() {
        if (this.status === ACTIVE) {
            this.emoneyDeactivateModalComponent.openModal();
        }
        else {
            this.status = ACTIVE;
            this.emoneyActivateModalComponent.openModal();
        }
    }
}
EMoneyIntegrationListItemComponent.ɵfac = function EMoneyIntegrationListItemComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || EMoneyIntegrationListItemComponent)(i0.ɵɵdirectiveInject(i1.EMoneyIntegrationService)); };
EMoneyIntegrationListItemComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: EMoneyIntegrationListItemComponent, selectors: [["tr", "ycn-emoney-integration-list-item", ""]], viewQuery: function EMoneyIntegrationListItemComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emoneyDeactivateModalComponent = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.emoneyActivateModalComponent = _t.first);
    } }, inputs: { clientId: "clientId", authUrl: "authUrl", redirectUri: "redirectUri" }, standalone: false, attrs: _c2, decls: 17, vars: 10, consts: [["emoneyActivateModalComponent", ""], ["emoneyDeactivateModalComponent", ""], [1, "table-logo"], ["ycnImage", "", 3, "imageSrc"], [1, "text-bold"], [3, "errorMessage", "status"], [1, "text-right"], [1, "custom-control", "custom-switch"], ["type", "checkbox", 1, "custom-control-input", 3, "change", "checked"], [1, "custom-control-indicator"], [3, "confirmHandler", "confirmButtonText", "confirmHeader", "confirmText"]], template: function EMoneyIntegrationListItemComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "td")(1, "div", 2);
        i0.ɵɵelement(2, "img", 3);
        i0.ɵɵelementStart(3, "div", 4);
        i0.ɵɵtext(4, "eMoney");
        i0.ɵɵelementEnd()()();
        i0.ɵɵelementStart(5, "td");
        i0.ɵɵtext(6, "Portfolio Holdings");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "td");
        i0.ɵɵelement(8, "ycn-integration-status-indicator", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "td", 6)(10, "label", 7)(11, "input", 8);
        i0.ɵɵlistener("change", function EMoneyIntegrationListItemComponent_Template_input_change_11_listener() { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.activateToggle()); });
        i0.ɵɵelementEnd();
        i0.ɵɵelement(12, "span", 9);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(13, "ycn-confirm-modal", 10, 0);
        i0.ɵɵlistener("confirmHandler", function EMoneyIntegrationListItemComponent_Template_ycn_confirm_modal_confirmHandler_13_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.activateHandler($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "ycn-confirm-modal", 10, 1);
        i0.ɵɵlistener("confirmHandler", function EMoneyIntegrationListItemComponent_Template_ycn_confirm_modal_confirmHandler_15_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.deactivateHandler($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("imageSrc", "integrations/images/emoney-logo.png");
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("errorMessage", ctx.errorMessage)("status", ctx.status);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("checked", ctx.status === "active");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmButtonText", "Log in to eMoney")("confirmHeader", "Activate eMoney Integration")("confirmText", ctx.innerHtml);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("confirmButtonText", "Deactivate")("confirmHeader", "Deactivate eMoney Integration")("confirmText", "Are you sure you would like to deactivate your integration with eMoney? You will not be able to use this integration unless you reactivate it.");
    } }, dependencies: [i2.ConfirmModalComponent, i3.ImageDirective, i4.IntegrationStatusIndicatorComponent], encapsulation: 2 });
